// @flow

import SendForm from 'components/SendResource/SendForm'
import SendPacket from 'components/SendResource/SendPacket'
import StartInternalForm from 'components/SendResource/StartInternalForm'
import usePermissions from 'hooks/usePermissions'
import * as React from 'react'
import { ZentakeContext } from 'utils/ZentakeContext'

const buttonStyle =
  'flex-1 justify-center py-2 px-4 border border-transparent text-xs sm:text-sm md:text-base md:leading-6 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:border-blue-700 focus:shadow-outline-blue active:bg-blue-700 transition duration-150 ease-in-out'

export default function SendButtons(): React.Node {
  const { teamDetails } = React.useContext(ZentakeContext)
  const [formToggle, setFormToggle] = React.useState(false)
  const [packetToggle, setPacketToggle] = React.useState(false)
  const [internalFormToggle, setInternalFormToggle] = React.useState(false)

  const toggleSendFormModal = () => {
    setFormToggle(!formToggle)
  }

  const toggleSendPacketModal = () => {
    setPacketToggle(!packetToggle)
  }

  const toggleInternalFormModal = () => {
    setInternalFormToggle(!internalFormToggle)
  }

  const { canSendResponse } = usePermissions()

  return (
    <>
      <div className="flex mb-4 lg:mb-0 md:w-full lg:w-1/2 lg:pr-3 space-x-2">
        {canSendResponse && (
          <>
            <button
              className={buttonStyle}
              onClick={toggleSendPacketModal}
              style={{ maxWidth: 200 }}
            >
              Send Packet
            </button>
            <button
              className={buttonStyle}
              onClick={toggleSendFormModal}
              style={{ maxWidth: 200 }}
            >
              Send Form
            </button>
            {teamDetails?.internal_forms ? (
              <button
                className={buttonStyle}
                onClick={toggleInternalFormModal}
                style={{ maxWidth: 200 }}
              >
                Start Internal Form
              </button>
            ) : null}
          </>
        )}
      </div>
      {packetToggle && <SendPacket onHide={toggleSendPacketModal} />}
      {formToggle && <SendForm onHide={toggleSendFormModal} />}
      {internalFormToggle && (
        <StartInternalForm onHide={toggleInternalFormModal} />
      )}
    </>
  )
}
